import reducer from './reducer';
import * as selectors from './selectors';
import * as actionTypes from './actionTypes';
import * as actions from './actions';

export default { reducer, selectors, actions, actionTypes };
